export default __webpack_public_path__ + "static/media/envoy.65ceabf7.svg";